module.exports = __webpack_public_path__ + "img/former-bg1.2cbec771.png";